<template lang="pug">
  .breadcrumbs
    a.breadcrumbs__item(href="#") Главная
    template(v-if="items.length" v-for="(item, i) in items")
      template(v-if="i !== items.length - 1")
        span &nbsp;{{ dropSymbol }}&nbsp;
        a.breadcrumbs__item(href="#") {{ item.name }}
      template(v-else)
        span &nbsp;{{ dropSymbol }}&nbsp;
        .breadcrumbs__no-hover {{ item.name }}

</template>

<script>
export default {
  name: 'BreadCrumbs',
  props: {
    items: {
      type: Array,
      required: true,
      default: () => ([{
        name: 'Личный кабинет',
      }]),
      validator: (value) => {
        let noError = true;
        value.forEach((e) => {
          if (!e.name || !e.link) {
            global.console.error('missing one or both "name" and "link" parameters');
            noError = false;
            return;
          }
          if (typeof e.name !== 'string' || typeof e.link !== 'string') {
            global.console.error('"name" and "link" must be type of a string');
            noError = false;
            return;
          }
          if (e.name.length < 1 || e.link.length < 1) {
            global.console.error('Strings not be empty');
            noError = false;
          }
        });
        return noError;
      },
    },
  },
  data: () => ({
    dropSymbol: '/',
  }),
};
</script>
